import styled from "styled-components";

export const StyledScrollTable = styled.div`
  overflow: auto;
  overflow-scrolling: touch;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 10px;
    background-color: ${({theme}) => theme.scrollbar.track};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-track{
    background-color: ${({theme}) => theme.scrollbar.track};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb {
    height: 16px;
    border: 2px solid ${({theme}) => theme.scrollbar.track};
    background: ${({theme}) => theme.scrollbar.thumb};
    border-radius: 12px;
  }
`;

export const StyledTable = styled.div`
  margin-bottom: 20px;
  font-size: ${({ size }) => size + "px"};
  ${({ width }) => width && `min-width: ${width}px`};
  ${({ width }) => width && "width: 100%"};
  ${({ width }) => width && "overflow-x: hidden;"};

  .table-action {
    padding: 0;
    margin: 0;
    color: inherit;
    text-align: left;
    background-color: transparent;
    border: none;
    outline: none;
    display: inline-block;
    transition: all .3s ease;
    span {
      font-size: 12px;
      padding-right: 8px;
    }
    &_info:hover {
      color: ${({theme}) => theme.table.actionInfoHover};
    }
    &_danger:hover {
      color: ${({theme}) => theme.table.actionDangerHover};
    }
  }
`;

export const StyledTableHead = styled.div`
  padding: 20px 15px;
  color: ${({theme}) => theme.table.headColor};
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: repeat(${({ col }) => col}, 1fr);
  grid-column-gap: 15px;
  font-weight: 600;
  @media screen and (max-width: 992px) {
    display: ${({ scroll }) => scroll === "auto" ? "grid" : "none"};
  }
`;

export const StyledTableBody = styled.div``;

export const StyledTableRow = styled.div`
  ${({cursor}) => cursor && `cursor: ${cursor}`};
  padding: 20px 15px;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: repeat(${({ col }) => col}, minmax(0, 1fr));
  grid-column-gap: 15px;
  border-top: 1px solid ${({theme}) => theme.table.border};
  &:last-child {
    border-bottom: 1px solid ${({theme}) => theme.table.border};
  }
  &:hover {
    color: ${({theme}) => theme.table.rowHoverColor};
    background-color: ${({theme}) => theme.table.rowHoverBackground};
  }
  @media screen and (max-width: 992px) {
    grid-template-rows: ${({ scroll }) => scroll === "auto" ? "1fr" : `repeat(${({ col }) => col}, minmax(50px, auto))`};
    grid-template-columns: ${({ scroll }) => scroll === "auto" ? `repeat(${({ col }) => col}, 150px)` : "1fr"};
    ${({ scroll }) => scroll && `
       & > div {
        margin-bottom: inherit;
        padding-top: 0;
         &:before {display: none}; 
        }
    `};
  }
`;

export const StyledCol = styled.div`
  display: ${({ inline }) => inline ? "inline-flex" : "grid"};
  align-items: center;
  position: relative;
  &:before {
    content: attr(data-title) ':';
    font-size: 11px;
    letter-spacing: 0.4px;
    opacity: .65;
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    @media screen and (max-width: 992px) {
      display: block;
    }
  }
  @media screen and (max-width: 992px) {
    margin-bottom: 5px;
    padding-top: 20px;
    align-items: start;
  }
`;
